<template>
  <div class="settingsWifi" id="wifi">
    <div
      style="
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 20px;
      "
    >
      <h1>{{ $t("langcfg.txtWifi") }}</h1>
      <el-switch v-model="wifiOn" style="zoom: 1.8" @change="changeWifiSwitch"> </el-switch>
    </div>
    <template v-if="wifiOn">
      <div
        style="
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 20px;
        "
      >
        <el-button type="primary" @click="onaddNetwork()" style="margin-left: 0">
          {{ $t("langcfg.txtAddNeworks") }}
        </el-button>
        <el-button type="info" @click="refreshTime()">
          <i class="iconfont icon-refresh"></i>
        </el-button>
      </div>
      <el-table
        v-loading="showLoading && !pwdInputShow"
        :element-loading-fullscreen="false"
        :element-loading-text="loadingMessage"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.3)"
        class="listTable"
        :data="services"
        :show-header="false"
        :empty-text="' '"
        :row-style="rowStyle"
        :cell-style="cellStyle"
        :max-height="320"
        @row-click="onWifiItemClick"
      >
        <el-table-column prop="ssid"></el-table-column>
        <el-table-column width="80">
          <template slot-scope="scope">
            <i :class="[isConnect(scope.row) ? 'iconfont icon-check' : '']"></i>
          </template>
        </el-table-column>
        <el-table-column width="70">
          <template slot-scope="scope">
            <icon-font
              :icon-href="scope.row.rssi"
              :icon-class="{ width: 20, height: 30, color: 'rgb(64,158,255)' }"
            />
          </template>
        </el-table-column>
        <el-table-column width="70">
          <template slot-scope="scope">
            <i v-if="scope.row.flag" class="iconfont icon-lock"></i>
          </template>
        </el-table-column>
      </el-table>
    </template>
    <div
      style="
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 20px;
      "
    >
      <h1>
        {{ $t("langcfg.txtLan") + (lanCfg.length ? "" : ` - ${$t("langcfg.txtNotConnected")}`) }}
      </h1>
      <el-button @click="openNmtui">{{ $t("langcfg.txtAdvancedSettings") }}</el-button>
    </div>
    <template v-if="lanCfg.length">
      <div
        v-for="(item, index) in lanCfg"
        :key="`lan_${index}`"
        style="display: flex; align-items: center; margin-bottom: 20px"
      >
        <network-info
          :wifiCfg="item"
          :isWifi="false"
          @disconnect="disconnectEthernet"
          @reconnect="reconnectEthernet"
        ></network-info>
      </div>
    </template>
    <div
      style="
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 20px;
      "
    >
      <h1>
        {{ $t("langcfg.txtDirectConnection") }}
      </h1>
      <el-radio-group
        class="radioContainer"
        v-model="netSelect"
        text-color="#00ff00"
        @change="netSelectChange"
      >
        <el-radio label="router" text-color="#00ff00">{{ $t("langcfg.txtRouterMode") }}</el-radio>
        <el-radio label="dhcp" text-color="#00ff00">{{ $t("langcfg.txtDHCPMode") }}</el-radio>
      </el-radio-group>
    </div>
    <div
      v-if="netSelect === 'router'"
      style="display: flex; align-items: center; margin-bottom: 20px"
    >
      {{ $t("langcfg.txtDirectIP") }}: {{ netSelectIP === undefined ? "" : netSelectIP }}
    </div>
    <password
      style="margin-bottom: 20px"
      :wifiItem="wifiItem"
      :hadInvalidKey="hadInvalidKey"
      v-if="pwdInputShow"
      :hasHide="hasHide"
      :show.sync="pwdInputShow"
      @hide="hide"
      @connect="pswConnect"
    />
    <wifi-config
      style="margin-bottom: 20px"
      v-if="wifiConfigShow"
      :show.sync="wifiConfigShow"
      :wifiItem="wifiItem"
      :wifiCfg="wifiCfg"
      @close="hide"
      @reconnect="reconnect"
      @disconnect="disconnect"
    ></wifi-config>
  </div>
</template>
<script>
import { Message } from "../../../mixins";
import Password from "./WifiPwd.vue";
import WifiConfig from "./WifiConfig";
import NetworkInfo from "./NetworkInfo";
import { isFunction, isDefined } from "../../../shared/utils";
import wpaWIfi from "../../js/wifi/wpa_wifi/index.js";
import IconFont from "../basic/iconFont.vue";
import EVENTS from "../../../bus";
import fileSys from "../../../fileoprators/fileSystem";
import ethernet from "../../js/ethernet/index";
import { saveSettings } from "../../../settings";

export default {
  data() {
    return {
      netSelect: "dhcp",
      netSelectIP: "",
      services: [],
      pwdInputShow: false,
      wifiItem: {},
      hasHide: false,
      stateWifi: {},
      wifiConfigShow: false,
      showLoading: false,
      loadingMessage: this.$t("langcfg.txtScanning"),
      hadInvalidKey: false,
      lanCfg: [],
      rowStyle: {
        color: "#ffffff",
        background: "rgba(0,0,0,0)"
      },
      cellStyle: {
        textAlign: "left",
        borderColor: "#4b505a",
        fontSize: "30px"
      },
      DebounceNumber: 0,
      timeDebounce: "",
      wifiCfg: {},
      wifiOn: false
    };
  },
  components: {
    IconFont,
    Password,
    WifiConfig,
    NetworkInfo
  },
  mixins: [Message],
  mounted: async function () {
    await this.getNetworkState();
    this.wifiOn = this.stateWifi.ConnStatus !== 9;
    this.refreshWlan(true);
    this.netSelect = window.settings.netSelect ? window.settings.netSelect : "dhcp";
    if (this.netSelect === "router") {
      this.setRouterIp();
    }
  },
  methods: {
    getNetworkState() {
      let check = () => {
        return Promise.all([ethernet.getConnectedLan(), wpaWIfi.stateWifi()]).then(
          ([ethernets, wifi]) => {
            this.lanCfg = ethernets;
            this.stateWifi = wifi;
            setTimeout(check, 500);
          }
        );
      };
      check();
    },
    async setRouterIp() {
      try {
        this.netSelectIP = await fileSys.getRouterIp();
      } catch (error) {}
    },
    async sleep(ms) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve();
        }, ms);
      });
    },
    async netSelectChange(val) {
      try {
        this.$bus.$emit(EVENTS.showGlobalWatting, "");
        this.lanCfg = [];
        await fileSys.selectRouterAndDhcpMode(val);
        window.settings.netSelect = val;
        saveSettings(window.settings);
        this.setRouterIp();
      } catch (error) {
        console.log("---netSelectChange error---", error);
        this.notify(this.$t("langcfg.txtPeizhiErr"), "", "error");
      } finally {
        await this.sleep(500);
        await this.getWireLan();
        this.$bus.$emit(EVENTS.hideGlobalWatting);
      }
    },
    openNmtui() {
      ethernet.openTui();
    },
    onaddNetwork() {
      this.pwdInputShow = true;
      this.hasHide = true;
    },
    getwifiState() {
      return wpaWIfi.stateWifi().then((state) => {
        setTimeout(() => {
          this.getwifiState();
        }, 1000 * 3);
        return state;
      });
    },
    async getWireLan() {
      this.lanCfg = await ethernet.getConnectedLan();
      console.log(this.lanCfg, "111");
    },
    calculateSignalLevel(rssi, numLevels) {
      let MIN_RSSI = -100;
      let MAX_RSSI = -55;
      if (rssi <= MIN_RSSI) {
        return 0;
      } else if (rssi >= MAX_RSSI) {
        return numLevels - 1;
      } else {
        let inputRange = MAX_RSSI - MIN_RSSI;
        let outputRange = numLevels - 1;
        return parseInt(((rssi - MIN_RSSI) * outputRange) / inputRange);
      }
    },
    onWifiItemClick(item, column, event) {
      this.wifiItem = item;
      if (this.isConnect(item)) {
        this.setWifi(item);
      } else {
        let wifiPwdRecord = wpaWIfi.getWifiPWdRe(item);
        if (isDefined(wifiPwdRecord)) {
          this.connect(item, wifiPwdRecord.psk, wifiPwdRecord.hasHide);
        } else {
          this.pwdInputShow = true;
          this.hasHide = false;
        }
      }
    },
    setWifi(item) {
      this.wifiItem = item;
      wpaWIfi
        .getWifiConfig()
        .then((cfg) => {
          this.wifiCfg = cfg;
          this.wifiConfigShow = true;
        })
        .catch((error) => {
          this.$alert(error.message);
        });
    },
    refreshWlan: function (showscan) {
      this.loadingMessage = this.$t("langcfg.txtScanning");
      this.showLoading = showscan;
      this.initWlan(true);
    },
    getWireLanName(index) {
      if (this.lanCfg.length > 1) {
        return index + 1;
      } else {
        return "";
      }
    },
    refreshTime() {
      if (this.DebounceNumber === 0) {
        this.refreshWlan(true);
        this.DebounceNumber = 5;
        this.timeDebounce = setTimeout(() => {
          if (this.DebounceNumber > 0) {
            this.DebounceNumber = 0;
          }
        }, 1000 * 5);
      } else {
        this.notify(this.$t("langcfg.txtFrequent"), "", "error");
      }
    },
    hide: function () {
      this.showLoading = false;
      this.pwdInputShow = false;
      this.wifiConfigShow = false;
      this.hadInvalidKey = false;
    },
    pswConnect: function (psw, ssid) {
      if (!isDefined(psw)) {
        this.notify(this.$t("langcfg.txtConnectFail"), "", "error");
      }
      this.hadInvalidKey = false;
      this.pwdInputShow = false;
      let hasHide = false;
      hasHide = this.hasHide;
      this.hasHide = false;
      this.$nextTick(() => {
        this.loadingMessage = this.$t("langcfg.txtWifiConnecting");
        this.showLoading = true;
        if (hasHide) {
          this.connect({ ssid: ssid }, psw, hasHide);
        } else {
          this.connect(this.wifiItem, psw, hasHide);
        }
      });
    },
    connect: function (item, pwd, hasHide = false) {
      if (this.isConnect(item)) return;

      this.showLoading = true;
      this.loadingMessage = this.$t("langcfg.txtConnecting");
      let cfg = {
        ssid: item.ssid,
        enabled: true,
        hasHide: hasHide,
        mode: "auto"
      };
      if (item.flag || hasHide) {
        cfg["psk"] = pwd;
      }
      wpaWIfi
        .connectWifi(cfg, hasHide)
        .then((data) => {
          if (data && typeof data === "boolean") {
            wpaWIfi.setWifiPwdRe(cfg, true);
            setTimeout(() => {
              this.showLoading = false;
              this.initWlan(true, () => {
                this.notify(this.$t("langcfg.txtConnectSuccessful"), "", "success");
              });
            }, 1000 * 3);
          }
        })
        .catch((reason) => {
          this.showLoading = false;
          wpaWIfi.setWifiPwdRe(cfg, false);
          console.log("wifi conect err", reason);
          // if (error.indices('set psk failed')) {
          //   this.notify(this.$t('langcfg.txtPasswordFaild'), '', 'error')
          // } else {
          //   this.notify(this.$t('langcfg.txtConnectFail'), '', 'error')
          // }
          this.notify(this.$t("langcfg.txtConnectFail"), "", "error");
        });
    },
    async reconnect(conParams) {
      this.showLoading = true;
      this.loadingMessage = this.$t("langcfg.txtConnecting");
      let wifiPwdRecord = wpaWIfi.getWifiPWdRe(conParams);
      if (!isDefined(wifiPwdRecord)) {
        this.pwdInputShow = true;
        this.hasHide = false;
        return;
      }
      let cfg = {
        ssid: conParams.ssid,
        enabled: true,
        hasHide: wifiPwdRecord.hasHide,
        mode: conParams.method,
        settings: {
          ip: conParams.address,
          netmask: conParams.netmask,
          gateway: conParams.gateway,
          dns: conParams.dns
        }
      };
      if (conParams.flag || wifiPwdRecord.hasHide) {
        cfg["psk"] = wifiPwdRecord.psk;
      }
      wpaWIfi
        .connectWifi(cfg, wifiPwdRecord.hasHide)
        .then((data) => {
          if (data && typeof data === "boolean") {
            wpaWIfi.setWifiPwdRe(cfg, true);
            setTimeout(() => {
              this.showLoading = false;
              this.initWlan(true, () => {
                this.notify(this.$t("langcfg.txtConnectSuccessful"), "", "success");
              });
            }, 1000 * 3);
          }
        })
        .catch((reason) => {
          this.showLoading = false;
          wpaWIfi.setWifiPwdRe(cfg, false);
          console.log("wifi conect err", reason);
          // if (error.indices('set psk failed')) {
          //   this.notify(this.$t('langcfg.txtPasswordFaild'), '', 'error')
          // } else {
          //   this.notify(this.$t('langcfg.txtConnectFail'), '', 'error')
          // }
          this.notify(this.$t("langcfg.txtConnectFail"), "", "error");
        });
    },
    disconnect() {
      this.wifiConfigShow = false;
      this.$bus.$emit(EVENTS.showGlobalWatting, this.$t("langcfg.txtDisconnect"));

      wpaWIfi
        .disconnectWifi()
        .then((data) => {
          fileSys.delWirelessRoute(() => {
            this.$bus.$emit(EVENTS.hideGlobalWatting);
            if (data) {
              this.refreshWlan(false);
            }
          });
        })
        .catch((error) => {
          console.log("error", error);
          fileSys.delWirelessRoute(() => {
            this.$bus.$emit(EVENTS.hideGlobalWatting);
          });
        });
    },
    async disconnectEthernet(lanInfo) {
      this.$bus.$emit(EVENTS.showGlobalWatting, this.$t("langcfg.txtDisconnect"));
      let disconnected = await ethernet.disconnectLan(lanInfo);
      await this.getWireLan();
      this.$bus.$emit(EVENTS.hideGlobalWatting);
    },
    async reconnectEthernet(lanInfo) {
      this.lanCfg = {};
      this.$bus.$emit(EVENTS.showGlobalWatting, this.$t("langcfg.txtConnecting"));
      let result;
      if (lanInfo.method === "auto") {
        result = await ethernet.setLanAuto(lanInfo);
      } else {
        result = await ethernet.setLanManual(lanInfo);
      }
      await this.getWireLan();
      this.$bus.$emit(EVENTS.hideGlobalWatting);
      if (result === false) {
        this.notify(this.$t("langcfg.txtConnectFail"), "", "error");
      }
    },
    initWlan: function (rescan = false, callback) {
      this.services = [];
      if (!this.showLoading) {
        this.loadingMessage = this.$t("langcfg.txtScanning");
        this.showLoading = true;
      }
      wpaWIfi.scanWifi().then((data) => {
        if (!isDefined(data)) {
          this.services = [];
          this.$nextTick(() => {
            this.showLoading = false;
          });
          if (isFunction(callback)) {
            callback();
          }
          return;
        }
        let wifiItems = data.map((item) => {
          item.freq = item.freq > 5000;
          let rssi = parseInt(item.rssi);
          let Num = this.calculateSignalLevel(rssi, 6);
          switch (Num) {
            case 0:
              item.rssi = "icon--wuxian-1";
              break;
            case 1:
              item.rssi = "icon--wuxian-";
              break;
            case 2:
              item.rssi = "icon--wuxian-4";
              break;
            case 3:
              item.rssi = "icon--wuxian-2";
              break;
            case 4:
              item.rssi = "icon--wuxian-3";
              break;
            case 5:
              item.rssi = "icon--wuxian-5";
              break;
            default:
              item.rssi = "icon--wuxian-1";
              break;
          }
          item.flag = item.flag.indexOf("[ESS]") > 0;
          return item;
        });
        let filter = [];
        for (let i = 0; i < wifiItems.length; i++) {
          for (let j = i + 1; j < wifiItems.length; j++) {
            if (
              wifiItems[i].ssid === wifiItems[j].ssid &&
              wifiItems[i].freq !== wifiItems[j].freq
            ) {
              filter.push(wifiItems[i].ssid);
            }
          }
        }
        wifiItems = wifiItems.filter((item) => !filter.includes(item.ssid) || !item.freq);
        for (let i = 0; i < wifiItems.length; i++) {
          if (this.isConnect(wifiItems[i])) {
            let val = wifiItems[0];
            wifiItems[0] = wifiItems[i];
            wifiItems[i] = val;
            break;
          }
        }
        setTimeout(() => {
          this.services = wifiItems;
          this.$nextTick(() => {
            this.showLoading = false;
          });
        }, 1000);
        if (isFunction(callback)) {
          callback();
        }
      });
    },
    getConnectWlan() {
      for (let i = 0; i < this.services.length; i++) {
        if (this.services[i] && this.services[i]["in-use"] === "*") {
          return this.services[i];
        }
      }
      return null;
    },
    isConnect(item) {
      return (
        this.stateWifi.bssid &&
        this.stateWifi.ssid === item.ssid &&
        parseInt(this.stateWifi.ConnStatus) === 4
      );
    },
    async changeWifiSwitch() {
      // this.$bus.$emit(EVENTS.showGlobalWatting, this.$t('langcfg.txtConnecting'))
      this.showLoading = true;
      if (this.wifiOn) {
        await wpaWIfi.enable();
        this.refreshWlan(false);
        this.showLoading = false;
      } else {
        await wpaWIfi.disable();
        this.services = [];
        this.$nextTick(() => {
          this.showLoading = false;
        });
      }
    }
  },
  computed: {
    isName: function () {
      return this.header;
    }
  }
};
</script>
<style lang="less" scoped>
/deep/ .el-switch__label * {
  font-size: 35px;
}
.el-button {
  margin-left: 1%;
  font-size: @header-fs;
  padding: 12px 15px;
  border: 1px solid gray;
}
.el-button:hover {
  opacity: 0.7;
}
</style>
<style>
.btn-wifis {
  width: 100%;
  display: flex;
  justify-content: center;
  align-content: center;
  position: relative;
}
.btn-addNeworks {
  text-align: center;
}
.settingsWifi {
  margin: 60px;
  width: 100%;
  font-size: 23px;
  color: white;
  display: flex;
  /*align-items: left;*/
  flex-direction: column;
  position: relative;
  z-index: 10;
}
.listTable {
  border: none;
  background: rgba(0, 0, 0, 0);
  margin-bottom: 20px;
}
#wifi .el-table .cell {
  line-height: 40px;
}
#wifi .el-table__body tr:hover > td {
  background-color: #4b505a !important;
}

#wifi .el-table__body tr.current-row > td {
  background-color: #4b505a !important;
}

#wifi i {
  font-size: 30px;
}
.config {
  padding-left: 5px;
  width: 50px;
  max-width: 50px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.scanningTip {
  font-size: 15px;
  /* position: fixed; */
  top: 236px;
  left: 355px;
  border-radius: 7px;
  background-color: black;
  text-align: center;
  color: white;
  width: 130px;
}

.click {
  cursor: pointer;
}
.btn-refresh {
  padding: 0px;
}

.radioContainer .el-radio {
  padding-left: 20px;
}

.radioContainer .el-radio /deep/ .el-radio__input {
  vertical-align: -5px !important;
}
</style>



// WEBPACK FOOTER //
// src/mainInterface/components/settings/Wifi.vue